import { NgClass, NgFor, NgIf } from "@angular/common";
import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { ExtendedModule } from "@angular/flex-layout/extended";
import { FlexModule } from "@angular/flex-layout/flex";
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from "@angular/material/sidenav";
import { Title } from "@angular/platform-browser";
import { NavigationEnd, NavigationStart, Router, RouterOutlet } from "@angular/router";
import { Subscription } from "rxjs";
import { environment } from "src/environments/environment";
import { CommonBreadcrumbsComponent } from "./common/common-breadcrumbs/common-breadcrumbs.component";
import { CommonChatbotComponent } from "./common/common-chatbot/common-chatbot.component";
import { CommonEnvironmentBannerComponent } from "./common/common-environment-banner/common-environment-banner.component";
import { CommonMessageComponent } from "./common/common-message/common-message.component";
import { HeaderComponent } from "./header/header.component";
import { MessageComponent } from "./message/message.component";
import { Breadcrumb } from "./models/breadcrumb.model";
import { CONSTANTS } from "./models/constants";
import { Message } from "./models/message.model";
import { BreadCrumbService } from "./service/bread-crumb.service";
import { DeviceService } from "./service/device.service";
import { MessageService } from "./service/message.service";
import { NavigationService } from "./service/navigation.service";
import { ThemeService } from "./service/theme.service";
import { IconService } from "./shared/services/icon.service";
import { SidenavComponent } from "./sidenav/sidenav.component";

declare const _etracker: any;
declare const et_eC_Wrapper: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  imports: [
    MatSidenavContainer,
    NgIf,
    NgFor,
    MatSidenav,
    NgClass,
    ExtendedModule,
    SidenavComponent,
    MatSidenavContent,
    FlexModule,
    HeaderComponent,
    MessageComponent,
    CommonBreadcrumbsComponent,
    CommonEnvironmentBannerComponent,
    CommonMessageComponent,
    RouterOutlet,
    CommonChatbotComponent,
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  title = "me-at-slalom";
  background = "";
  private breadcrumbsSubscription?: Subscription;
  private messagesSubscription?: Subscription;
  private routerSubscription?: Subscription;
  private themeSubscription?: Subscription;
  bannerMessages: Message[] = [];
  showChatbot = environment.showChatBot;
  showEnvironmentBanner = environment.showEnvironmentBanner;

  breadcrumbs: Breadcrumb[] = [];

  constructor(
    public navigationService: NavigationService,
    public deviceService: DeviceService,
    private titleService: Title,
    private breadCrumbService: BreadCrumbService,
    private router: Router,
    private themeService: ThemeService,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef,
    public iconService: IconService
  ) {}

  ngOnInit() {
    this.setBackground();
    this.titleService.setTitle(CONSTANTS.APP_TITLE);
    if (this.deviceService.isLargeScreen()) {
      this.navigationService.opened = false;
    }

    this.breadcrumbsSubscription = this.breadCrumbService.breadcrumbs$.subscribe((breadcrumbs) => {
      this.breadcrumbs = breadcrumbs;
      this.cdr.detectChanges();
    });

    this.messagesSubscription = this.messageService.currentMessages$.subscribe((messages) => {
      this.bannerMessages = messages.filter((message) => message.isBanner);
      this.cdr.detectChanges();
    });

    this.routerSubscription = this.router.events
      // .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          if (
            !event.url.includes("?") &&
            !event.url.includes("insights") &&
            !event.url.includes("search") &&
            !event.url.includes("my-work") &&
            !event.url.includes("staffing-opportunities")
          ) {
            this.breadCrumbService.clearBreadCrumbs();
          }
          this.messageService.clearBannerMessages();
        }

        // Track page views in etracker for SPA navigation
        if (event instanceof NavigationEnd) {
          if (typeof et_eC_Wrapper === "function") {
            et_eC_Wrapper({
              et_et: environment.etrackerCode,
              et_pagename: event.urlAfterRedirects,
            });
          }
        }
      });
    this.themeSubscription = this.themeService.themeChanged().subscribe(() => {
      this.setBackground();
    });
  }

  ngOnDestroy() {
    this.breadcrumbsSubscription?.unsubscribe();
    this.messagesSubscription?.unsubscribe();
    this.routerSubscription?.unsubscribe();
    this.themeSubscription?.unsubscribe();
  }

  trackByMessageId(_index: number, message: Message) {
    return message.id;
  }

  setBackground() {
    switch (this.themeService.activeTheme) {
      case "slalom-light-theme":
        this.background = "./assets/me-at-slalom-background-light.svg";
        break;
      case "slalom-dark-theme":
        this.background = "./assets/me-at-slalom-background-dark.svg";
        break;
      case "midnight-dark-theme":
        this.background = "./assets/me-at-slalom-background-midnight.svg";
        break;
    }
  }

  backdropClick() {
    this.navigationService.opened = false;
  }

  @HostListener("window:resize")
  onResize() {
    if (!this.deviceService.isLargeScreen()) {
      this.navigationService.opened = false;
    }
  }
}
